
import { useState } from "react";
import AcademicPlanner from "../Assets/Gulf_Students/Resource_Vault_Success/academic-planner.png";
import CareerPrep from "../Assets/Gulf_Students/Resource_Vault_Success/career-prep.png";
import GulfAlumni from "../Assets/Gulf_Students/Resource_Vault_Success/get-alumni-spotlight.png";
import MentorshipOnboard from "../Assets/Gulf_Students/Resource_Vault_Success/mentorship-guide.png";
import Scholarship from "../Assets/Gulf_Students/Resource_Vault_Success/scholarship_tracker.png";
import TimeManagement from "../Assets/Gulf_Students/Resource_Vault_Success/time-management.png";
import VisaPrep from "../Assets/Gulf_Students/Resource_Vault_Success/visa-prep.png";
import GulfStudentsData from "../Data/Gulf_Students/GulfStudentsData";
import "../Gulf_Students/CSS/GulfStudentsCSS.css";
import "../Gulf_Students/CSS/GulfStudentsForm.css";
import "../Gulf_Students/CSS/ThanksPage.css";
import CareerPrepKit from "../PDFs/Career-Prep-Kit-for-Study-Abroad-Students.pdf";
import GulfAlumniSpotlight from "../PDFs/Gulf-Alumni-Spotlight-Series.pdf";
import GulfStudentDepartureChecklist from "../PDFs/Gulf-Student-Departure-Checklist.pdf";
import ScholarshipTracker from "../PDFs/Scholarship-Tracker-for-Study-Abroad-Students.pdf";
import StudyAbroadPackingList from "../PDFs/Study-Abroad-Packing-List.pdf";
import TimeManagementTemplates from "../PDFs/Time-Management-Templates-for-Study-Abroad-Students.pdf";

const ResourceVaultSuccess = () => {
  const [email, setEmail] = useState();
  const handleDownload = (pdfFile, fileName) => {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = fileName;
    link.click();
  };
  return (
    <>
      <section className="thank-you-page-main-section">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 thank-you-page-heading-para-div">
              <h1>Thank you for submitting the request.</h1>
              <h2>You now have access to our full resource library for Gulf students.</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="other-services-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 other-services-heading-div">
              <h2>Resource <span>Vault</span></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-3">
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={CareerPrep} alt="" />
                </div>
                <h5>Departure Checklist PDF</h5>
                <button onClick={() => handleDownload(GulfStudentDepartureChecklist, "Gulf-Student-Departure-Checklist.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={CareerPrep} alt="" />
                </div>
                <h5>Study Abroad Packing List PDF</h5>
                <button onClick={() => handleDownload(StudyAbroadPackingList, "Study-Abroad-Packing-List.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={VisaPrep} alt="" />
                </div>
                <h5>Visa Prep Guide PDF</h5>
                <button>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={AcademicPlanner} alt="" />
                </div>
                <h5>Academic Planner PDF</h5>
                <button onClick={() => handleDownload(AcademicPlanner, "Academic-Planner-for-Study-Abroad-Students.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={MentorshipOnboard} alt="" />
                </div>
                <h5>Mentorship Onboarding Guide PDF</h5>
                <button>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={Scholarship} alt="" />
                </div>
                <h5>Scholarship Tracker Excel Template</h5>
                <button onClick={() => handleDownload(ScholarshipTracker, "Scholarship-Tracker-for-Study-Abroad-Students.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={CareerPrep} alt="" />
                </div>
                <h5>Career Prep Kit PDF</h5>
                <button onClick={() => handleDownload(CareerPrepKit, "Career-Prep-Kit-for-Study-Abroad-Students.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={TimeManagement} alt="" />
                </div>
                <h5>Time Management Templates PDF</h5>
                <button onClick={() => handleDownload(TimeManagementTemplates, "Time-Management-Templates-for-Study-Abroad-Students.pdf")}>Download It Now</button>
              </div>
            </div>
            <div className="col resource-vault-card-div">
              <div className="resource-vault-card-inner-div">
                <div className="what-we-offer-card-icon">
                  <img src={GulfAlumni} alt="" />
                </div>
                <h5>Gulf Alumni Spotlight Series PDF</h5>
                <button onClick={() => handleDownload(GulfAlumniSpotlight, "Gulf-Alumni-Spotlight-Series.pdf")}>Download It Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="other-services-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 other-services-heading-div">
              <h2>Other <span>Services</span></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
            {
              GulfStudentsData.filter(item => item.id !== 5)
                .map((item) => {
                  return (
                    <div className="col our-services-card-div" key={item.id}>
                      <div className="our-services-card-inner-div">
                        <div className="what-we-offer-card-icon">
                          <img src={item.bannerImg} alt="" />
                        </div>
                        <h5>{item.heading}</h5>
                        <p>{item.text}</p>
                        {item.link}
                      </div>
                    </div>
                  )
                })
            }
          </div>
        </div>
      </section>
      <section className="subscribe-form-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 subscribe-heading-form-div">
              <h2>Want to receive monthly updates and new tools?</h2>
              <h4>Subscribe to the Gulf Student Insider newsletter.</h4>
            </div>
            <div className="row justify-content-center subscribe-form-div">
              <form method="post" className="subscribe-form" name="subscribe-form" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit="submit">
                <input type="hidden" name="form-name" value="subscribe-form" />
                <div className="col-md-8 col-md-4 mb-3 gulf-students-services-form-div">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="col-md-4 mb-3 gulf-students-services-button-div subscribe-form-button">
                  <button type="submit">Subscribe Now</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ResourceVaultSuccess